import { Button, Col, DatePicker, Tooltip } from "antd";
import { Radio } from "antd";
import { Input } from "antd";
import { Form, Row } from "antd";
import React, { FC, useEffect, useState } from "react";
import { Document } from "../../PreAuth/PreAuthIhx/PreAuthIhx";
import { Upload } from "antd";
import { CheckOutlined, EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { useUserFunctionalities } from "../../../../utils/UserFunctionalities";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { ROUTES } from "../../../../utils/constants";
import { useNavigate } from "react-router-dom";

type ClaimIhxProps = {
  documentTypes: Document[];
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks: string | null;
  }[];
  handleFileChange: any;
  handleOpen: any;
  form: any;
  handleSubmit: any;
  handleSubmitOnPortal: any;
  handleApprove: any;
  isApproved: boolean;
  isApprovedInitiated: boolean;
  caseClaimId: any;
  isSubmitting: boolean;
  isSaving: boolean;
  currentActiveStage: any;
  handleSaveConfirmationModal: any;
  documentRequestResponseDocuments: any;
  handleSaveData: any;
  activeKey: any;
  preAuth: any;
  portalSubmission: boolean;
  loading: boolean;
  isIntimating: boolean;
  claimData: any;
  uploadFileList: any;
};

const ClaimIhx: FC<ClaimIhxProps> = ({
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  form,
  handleSubmit,
  handleSubmitOnPortal,
  handleApprove,
  isApproved,
  isApprovedInitiated,
  caseClaimId,
  isSubmitting,
  isSaving,
  currentActiveStage,
  handleSaveConfirmationModal,
  documentRequestResponseDocuments,
  handleSaveData,
  activeKey,
  preAuth,
  portalSubmission,
  loading,
  isIntimating,
  claimData,
  uploadFileList
}) => {
  const { hasFunctionality } = useUserFunctionalities();
  const showData =
    preAuth?.stepperData?.currentVisitStage?.visitStageId <=
    parseInt(activeKey);
  const { auth, patients } = useSelector((state: RootState) => state);
  const navigate = useNavigate();

  const dateFormat = "DD-MM-YYYY HH:mm:ss";

  const [updatedRequestDocumentUrls, setUpdatedRequestDocumentUrls] =
    useState<any>();
  const [updatedResponseDocumentUrls, setUpdatedResponseDocumentUrls] =
    useState<any>();

  useEffect(() => {
    const uploadedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["requestedDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType
      )
    );

    setUpdatedRequestDocumentUrls(uploadedDocumentUrls);
  }, [documentRequestResponseDocuments, documentUrls]);

  useEffect(() => {
    const uploadedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["responseDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType
      )
    );

    setUpdatedResponseDocumentUrls(uploadedDocumentUrls);
  }, [documentRequestResponseDocuments, documentUrls]);

  const groupByLabelType = (docs: any[]) => {
  return docs?.reduce((acc: any, doc: any) => {
    const label = doc.documentLabelType;
    if (!acc[label]) acc[label] = [];
    acc[label].push(doc);
    return acc;
  }, {});
};

  return (
    <div style={{ overflow: "auto" }}>
      <Form form={form} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Claim No."
              name="claimNo"
              style={{ color: "#575757" }}
            >
              <Input
                placeholder="Please input claim no"
                style={{ color: "black" }}
                disabled={true}
              />
            </Form.Item>
          </Col>

          {/* <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Date of admission"
              name="doa"
              style={{ color: "#575757" }}
            >
              <DatePicker
                placeholder="Please input doa"
                style={{ color: "black", width: "100%" }}
                disabled={true}
                format={dateFormat}
              />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Date of discharge"
              name="dod"
              style={{ color: "#575757" }}
            >
              <DatePicker
                placeholder="Please input dod"
                format={dateFormat}
                style={{ color: "black", width: "100%" }}
                disabled={true}
              />
            </Form.Item>
          </Col> */}

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Claimed Amount"
              name="claimedAmount"
              style={{ color: "#575757" }}
            >
              <Input
                placeholder="Please input claimed amount"
                style={{ color: "black" }}
                disabled={true}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Approved Amount"
              name="approvedAmount"
              style={{ color: "#575757" }}
            >
              <Input
                placeholder="Please input Approved amount"
                style={{ color: "black" }}
                disabled={true}
              />
            </Form.Item>
          </Col>

          {/* <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label=""
              name="radioButtonForUploadDocuments"
              style={{ color: "black" }}
              //   rules={[
              //     {
              //       required: true,
              //       message: "Please select discharge or death",
              //     },
              //   ]}
            >
              <Radio.Group
                options={[
                  {
                    label: "Upload Settlement documents",
                    value: "Upload Settlement documents",
                  },
                  // { label: "NO", value: "false" },
                ]}
              />
            </Form.Item>
          </Col> */}

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Date of admission"
              name="dateOfAdmission"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input date of admission",
                },
              ]}
            >
              <DatePicker
                placeholder="Please input doa"
                style={{ color: "black", width: "100%" }}
                format={dateFormat}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Date of discharge"
              name="dateOfDischarge"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input date of discharge",
                },
              ]}
            >
              <DatePicker
                placeholder="Please input dateOfDischarge"
                style={{ color: "black", width: "100%" }}
                format={dateFormat}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Is the patient getting discharged today?"
              name="patientDischargeToday"
              style={{ color: "black" }}
              //   rules={[
              //     {
              //       required: true,
              //       message: "Please select discharge or death",
              //     },
              //   ]}
            >
              <Radio.Group
                disabled={portalSubmission}
                options={[
                  { label: "YES", value: "true" },
                  { label: "NO", value: "false" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Has the patient utilized this PA?"
              name="patientUtilizedPA"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please select has the patient utilized this pa",
                },
              ]}
            >
              <Radio.Group
                disabled={portalSubmission}
                options={[
                  { label: "YES", value: "true" },
                  { label: "NO", value: "false" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Patient paid amount"
              name="patientPaidAmount"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input patient paid amount",
                },
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input
                placeholder="Please input Patient paid amount"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="inpatient No"
              name="impatientNo"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input impatient no",
                },
              ]}
            >
              <Input
                placeholder="Please input inpatient No"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Receipt No"
              name="receiptNo"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input receipt no",
                },
              ]}
            >
              <Input
                placeholder="Please input Receipt No"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Remarks"
              name="remarks"
              style={{ color: "#575757" }}
            >
              <Input
                placeholder="Please input Remarks"
                style={{ color: "black" }}
                disabled={portalSubmission}
              />
            </Form.Item>
          </Col>
        </Row>

        {loading ? (
          <div
            style={{
              margin: "auto",
              width: "100%,",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          documentRequestResponseDocuments?.["requestedDocuments"]?.length >
            0 && (
            <div>
              <div
                style={{
                  textDecoration: "underline",
                  fontSize: "16px",
                  margin: "16px 0",
                  fontWeight: "bold",
                }}
              >
                Request Document Upload
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: 20,
                }}
              >
                {documentRequestResponseDocuments?.["requestedDocuments"]
                  ?.length > 0 &&
                  documentRequestResponseDocuments?.["requestedDocuments"]?.map(
                    (docType: any) => {
                      const matchingDocuments = documentUrls?.filter(
                        (doc) => doc.documentLabelType === docType.label
                      );

                      if (matchingDocuments?.length > 0 && !docType?.multiple) {
                        return null;
                      }

                      return (
                        <div
                          key={docType.id}
                          style={{
                            border: "1px solid #eee",
                            padding: 10,
                            borderRadius: 8,
                            display: "flex",
                            alignItems: "center",
                            // gap: 8,
                          }}
                        >
                          {matchingDocuments?.length > 0 &&
                          !docType?.multiple ? (
                            <p></p>
                          ) : (
                            <Upload
                              multiple={docType?.multiple}
                               {...(docType?.multiple ? { fileList: uploadFileList } : {})}
                              showUploadList={false}
                              beforeUpload={() => false}
                              onChange={
                                handleFileChange &&
                                handleFileChange(docType?.labelId, docType?.multiple)
                              }
                              disabled={portalSubmission}
                            >
                              <Button
                                icon={<UploadOutlined />}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  borderRadius: 0,
                                  border: "none",
                                  borderTopLeftRadius: "6px",
                                  borderBottomLeftRadius: "6px",
                                }}
                                // disabled={(auth?.role?.role === "FO_STAFF" && claimData?.intimated) || portalSubmission || isApproved}
                                disabled={portalSubmission}
                              ></Button>
                            </Upload>
                          )}
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Button
                              style={{
                                borderRadius: 0,
                                border: "none",
                                paddingLeft: 4,
                                borderTopRightRadius: "6px",
                                borderBottomRightRadius: "6px",
                              }}
                              iconPosition={"end"}
                              // icon={
                              //   matchingDocuments?.length > 0 ? (
                              //     <EyeOutlined
                              //       style={{ marginLeft: "0.6rem" }}
                              //       onClick={() => {
                              //         handleOpen(
                              //           matchingDocuments?.[0]
                              //             ?.documentLabelType
                              //         );
                              //       }}
                              //     />
                              //   ) : (
                              //     <></>
                              //   )
                              // }
                            >
                              {docType.label}{" "}
                              {docType?.required ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : (
                                <></>
                              )}
                            </Button>
                          </div>
                        </div>
                      );
                    }
                  )}
              </div>
            </div>
          )
        )}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 10,
            borderTop:
              updatedRequestDocumentUrls?.length > 0
                ? "1px solid gray"
                : "none",
          }}
        >
          {Object.entries(
              groupByLabelType(updatedRequestDocumentUrls || [])
            )?.map(([labelType, docs]: [any, any]) =>
              docs.map((docType: any, idx: any) => (
                <div
                  key={docType.id}
                  style={{
                    border: "1px solid #eee",
                    padding: 10,
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",

                    // gap: 8,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      style={{
                        borderRadius: "6px",
                        border: "none",
                        paddingLeft: 20,
                        // borderTopRightRadius: "6px",
                        // borderBottomRightRadius: "6px",
                        background: docType?.deficiencyCheckStatus
                          ? "rgb(0, 109, 119)"
                          : docType?.deficiencyCheckStatus === "false" ||
                            docType?.deficiencyCheckStatus === false
                          ? "#DD2025"
                          : "#fff",
                        color:
                          docType?.deficiencyCheckStatus ||
                          docType?.deficiencyCheckStatus === false
                            ? "white"
                            : "black",
                      }}
                      iconPosition={"end"}
                      icon={
                        <EyeOutlined
                          style={{ marginLeft: "0.6rem" }}
                          onClick={() => {
                            handleOpen(docType?.documentLabelType, docType?.documentUrl);
                          }}
                        />
                      }
                    >
                      {docType?.documentLabelType} {idx + 1}{" "}
                    </Button>
                  </div>
                </div>
              ))
            )}
        </div>

        {documentRequestResponseDocuments?.["responseDocuments"]?.length >
          0 && (
          <div>
            <div
              style={{
                textDecoration: "underline",
                fontSize: "16px",
                margin: "16px 0",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              Response Document Upload
              {showData && portalSubmission ? (
                <Tooltip title={"Submit Response Documents"}>
                  <CheckOutlined onClick={handleSaveData} />{" "}
                </Tooltip>
              ) : (
                <></>
              )}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: 20,
                opacity: portalSubmission ? 1 : 0.5,
                pointerEvents: portalSubmission ? "auto" : "none",
              }}
            >
              {documentRequestResponseDocuments?.["responseDocuments"]?.length >
                0 &&
                documentRequestResponseDocuments?.["responseDocuments"]?.map(
                  (docType: any) => {
                    const matchingDocuments = documentUrls?.filter(
                      (doc) => doc.documentLabelType === docType.label
                    );

                    return (
                      <div
                        key={docType.id}
                        style={{
                          border: "1px solid #eee",
                          padding: 10,
                          borderRadius: 8,
                          display: "flex",
                          alignItems: "center",
                          // gap: 8,
                        }}
                      >
                        <Upload
                          multiple={docType?.multiple}
                           {...(docType?.multiple ? { fileList: uploadFileList } : {})}
                          showUploadList={false}
                          beforeUpload={() => false}
                          onChange={
                            handleFileChange &&
                            handleFileChange(docType?.labelId, docType?.multiple)
                          }
                          disabled={!portalSubmission}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            style={{
                              // width: "100%",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: 0,
                              border: "none",
                              borderTopLeftRadius: "6px",
                              borderBottomLeftRadius: "6px",
                            }}
                            // disabled={!showData}
                            disabled={!portalSubmission}
                          >
                            {/* {docType.label}{" "}
                  {docType?.required ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : (
                    <></>
                  )} */}
                          </Button>
                        </Upload>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Button
                            style={{
                              borderRadius: 0,
                              border: "none",
                              paddingLeft: 0,
                              borderTopRightRadius: "6px",
                              borderBottomRightRadius: "6px",
                            }}
                            iconPosition={"end"}
                            // icon={
                            //   matchingDocuments?.length > 0 ? (
                            //     <EyeOutlined
                            //       style={{ marginLeft: "0.6rem" }}
                            //       onClick={() => {
                            //         handleOpen(
                            //           matchingDocuments?.[0]?.documentLabelType
                            //         );
                            //       }}
                            //     />
                            //   ) : (
                            //     <></>
                            //   )
                            // }
                          >
                            {docType.label}{" "}
                            {docType?.required ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : (
                              <></>
                            )}
                          </Button>
                        </div>

                        {/* {matchingDocuments?.length > 0 && (
                <EyeOutlined
                  style={{ marginLeft: "0.6rem" }}
                  onClick={() => {
                    handleOpen();
                  }}
                />
              )} */}
                      </div>
                    );
                  }
                )}
            </div>
          </div>
        )}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 10,
            borderTop:
              updatedResponseDocumentUrls?.length > 0
                ? "1px solid gray"
                : "none",
          }}
        >
          {Object.entries(
              groupByLabelType(updatedResponseDocumentUrls || [])
            )?.map(([labelType, docs]: [any, any]) =>
              docs.map((docType: any, idx: any) => (
                <div
                  key={docType.id}
                  style={{
                    border: "1px solid #eee",
                    padding: 10,
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",

                    // gap: 8,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      style={{
                        borderRadius: "6px",
                        border: "none",
                        paddingLeft: 20,
                        // borderTopRightRadius: "6px",
                        // borderBottomRightRadius: "6px",
                        background: docType?.deficiencyCheckStatus
                          ? "rgb(0, 109, 119)"
                          : docType?.deficiencyCheckStatus === "false" ||
                            docType?.deficiencyCheckStatus === false
                          ? "#DD2025"
                          : "#fff",
                        color:
                          docType?.deficiencyCheckStatus ||
                          docType?.deficiencyCheckStatus === false
                            ? "white"
                            : "black",
                      }}
                      iconPosition={"end"}
                      icon={
                        <EyeOutlined
                          style={{ marginLeft: "0.6rem" }}
                          onClick={() => {
                            handleOpen(docType?.documentLabelType, docType?.documentUrl);
                          }}
                        />
                      }
                    >
                      {docType?.documentLabelType} {idx + 1}{" "}
                    </Button>
                  </div>
                </div>
              ))
            )}
        </div>

        <div className="buttons" style={{ margin: "16px 0" }}>
          {
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.8rem",
              }}
            >
              {claimData?.submitted ||
              claimData?.initiated
              // || claimData?.approved 
              ? (
                <></>
              ) : !caseClaimId ? (
                hasFunctionality("claimCreation") && (
                  <div style={{ width: "16%" }}>
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "rgb(0, 76, 143)",
                        color: "#fff",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        width: "100%",
                      }}
                      // onClick={handleSubmit}
                      onClick={() => handleSaveConfirmationModal("save")}
                      loading={isSaving}
                    >
                      SAVE
                    </Button>
                  </div>
                )
              ) : (
                hasFunctionality("claimCreation") &&
                // !(auth?.role?.role == "FO_STAFF" && claimData?.intimated) &&
                 (
                  <div style={{ width: "16%" }}>
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "rgb(0, 76, 143)",
                        color: "#fff",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        width: "100%",
                      }}
                      // onClick={handleSubmit}
                      onClick={() => handleSaveConfirmationModal("update")}
                      loading={isSaving}
                    >
                      Update
                    </Button>
                  </div>
                )
              )}

              {hasFunctionality("claimIntimation") ? (
                currentActiveStage?.visitStage == "Claim" &&
                (claimData?.intimated ||
                  claimData?.submitted ||
                  claimData?.initiated ||
                  claimData?.approved) ? (
                  <></>
                ) : (
                  <div style={{ width: "16%" }}>
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "rgb(0, 76, 143)",
                        color: "#fff",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        width: "100%",
                      }}
                      // onClick={handleIntimate}
                      onClick={() => handleSaveConfirmationModal("intimate")}
                      loading={isIntimating}
                    >
                      Send To QC
                    </Button>
                  </div>
                )
              ) : (
                <></>
              )}

              {/* {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() === "OP" &&
                (hasFunctionality("opdBillList") ||
                  hasFunctionality("ipdBillList")) && (
                  <div style={{ width: "16%" }}>
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "rgb(0, 76, 143)",
                        color: "#fff",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        width: "100%",
                        opacity: !isApproved ? 1 : 0.5,
                        pointerEvents: !isApproved ? "auto" : "none",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
                          navigate({
                            pathname: `${ROUTES.PATIENT_BILLING_LIST}/${patients?.fetchBasicDetails?.casesResponse?.id}/${patients?.fetchBasicDetails?.visitInfoResponse?.id}`,
                          });
                        }
                      }}
                    >
                      Bill Audit
                    </Button>
                  </div>
                )} */}

              {hasFunctionality("claimApprover") &&
                !claimData?.initiated &&
                !claimData?.approved &&
                !claimData?.submitted && (
                  <div style={{ width: "16%" }}>
                    <Button
                      loading={isApprovedInitiated}
                      type="primary"
                      style={{
                        backgroundColor: "rgb(0, 76, 143)",
                        color: "#fff",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        width: "100%",
                        opacity: !isApproved ? 1 : 0.5,
                        pointerEvents: !isApproved ? "auto" : "none",
                      }}
                      // onClick={handleApprove}
                      onClick={() => handleSaveConfirmationModal("approve")}
                      disabled={isApproved || portalSubmission}
                    >
                      QC Approve
                    </Button>
                  </div>
                )}

              {claimData?.submitted || claimData?.initiated ? (
                <></>
              ) : (
                hasFunctionality("claimSubmission") && (
                  <div style={{ width: "16%" }}>
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "rgb(0, 76, 143)",
                        color: "#fff",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        width: "100%",
                      }}
                      // onClick={handleSubmitOnPortal}
                      onClick={() => handleSaveConfirmationModal("submit")}
                      loading={isSubmitting}
                    >
                      {patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal ? "Initiate" : "Submit Manually"}
                    </Button>
                  </div>
                )
              )}
            </div>
          }
        </div>
      </Form>
    </div>
  );
};

export default React.memo(ClaimIhx);
